<template>
<div class="infopoints_view">
<b-container fluid>
    <b-row>
        <b-col lg="8">
            <card>
                <DisplayLayoutTable 
                    @selectItem="onSelectItem"
                    @newItem="onNewItem"
                    :item="item ? item.id : null">
                </DisplayLayoutTable>
            </card>
        </b-col>
        <b-col>
            <InfoCard v-if="action == ''"></InfoCard>

            <card v-if="action == 'new'">
                <CardHeader :title="$t('item.new')"/>
                <DisplayLayoutEditor :item="item" action="new" @itemSaved="onSelectItem"/>
            </card>

            <card v-if="action == 'item' && item">
                <CardHeader :title="item ? item.uniqueId : ''" type="item" />
                <tabs>
                     <tab-pane  title="tab-1" key="tab-1">
                        <b-icon slot="title" icon="card-list" scale="1.1"></b-icon>
                        <DisplayLayoutEditor :item="item" action="edit" />
                    </tab-pane>
                </tabs>
            </card>   
 
        </b-col>
    </b-row>
</b-container>
</div>
</template>

<script>

import DisplayLayoutTable from '@/components/Layout/DisplayLayoutTable'
import DisplayLayoutEditor from '@/components/Layout/DisplayLayoutEditor'

export default {
    name: 'DisplayLayouts',
    components: {
        DisplayLayoutTable,
        DisplayLayoutEditor
    },
    data: function() {
        return {
            action: "",
            item: {}
        }
    },
    watch: {
        item() {
            //if(!this.item) this.action = "";
        } 
    },
    methods: {
        onNewItem() {
            this.item = null;
            this.action = "new"
        },
        onSelectItem(item) {
            this.item = item;
            this.action = "item"
        }
    }
}
</script>
